import script from "./DownloadCenter2.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadCenter2.vue?vue&type=script&setup=true&lang=js"

import "./DownloadCenter2.vue?vue&type=style&index=0&id=39c04024&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39c04024"]])

export default __exports__